import type { ChangelogComment } from "../Services/http.clients/http.changelog.client";

interface ChangelogCommentConfig {
  enableUserComm?: string;
  feedbackPortal?: { disableChangelogComments?: boolean };
}

interface ChangelogCommentSession {
  userId?: string;
}

const isIdentified = (session?: ChangelogCommentSession | null) =>
  typeof session?.userId === "string" && session.userId.length > 0;

/**
 * Mirrors the server (changelogCommentAccess.ts): the feedback portal's
 * "Changelog comments" switch hides the whole section, "Write comments"
 * (enableUserComm, unset = everyone) decides who gets the composer. Reading
 * follows the server's answer: it only returns what this visitor may see.
 */
export const changelogCommentsEnabled = (config?: ChangelogCommentConfig) =>
  config?.feedbackPortal?.disableChangelogComments !== true;

export const canWriteChangelogComment = (
  config: ChangelogCommentConfig | undefined,
  session?: ChangelogCommentSession | null,
) => {
  if (!session || !changelogCommentsEnabled(config)) return false;
  if (config?.enableUserComm === "nobody") return false;
  if (config?.enableUserComm === "identified") return isIdentified(session);
  return true;
};

/** A plain-text comment as the TipTap document the portal and dashboard render. */
export const textToCommentDoc = (text: string) => ({
  type: "doc",
  content: text
    .trim()
    .split("\n")
    .map((line) => ({
      type: "paragraph",
      content: line.length > 0 ? [{ type: "text", text: line }] : [],
    })),
});

export const commentAuthorName = (
  comment: ChangelogComment,
  guestLabel: string,
) =>
  [comment.user?.firstName, comment.user?.lastName].filter(Boolean).join(" ") ||
  comment.session?.name ||
  guestLabel;
